import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import PropTypes from 'prop-types';
import { LocalizationProvider as XLocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { jsx as _jsx } from "react/jsx-runtime";
let warnedOnce = false;

const warn = () => {
  if (!warnedOnce) {
    console.warn(['MUI: The LocalizationProvider component was moved from `@mui/lab` to `@mui/x-date-pickers`.', 'The component will no longer be exported from `@mui/lab` in the first release of July 2022.', '', "You should use `import { LocalizationProvider } from '@mui/x-date-pickers'`", "or `import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'`", '', 'More information about this migration on our blog: https://mui.com/blog/lab-date-pickers-to-mui-x/.'].join('\n'));
    warnedOnce = true;
  }
};

/**
 * @ignore - do not document.
 */
const LocalizationProvider = /*#__PURE__*/React.forwardRef(function DeprecatedLocalizationProvider(props, ref) {
  warn();
  return /*#__PURE__*/_jsx(XLocalizationProvider, _extends({
    ref: ref
  }, props));
});
process.env.NODE_ENV !== "production" ? LocalizationProvider.propTypes
/* remove-proptypes */
= {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------

  /**
   * @ignore
   */
  children: PropTypes.node
} : void 0;
export default LocalizationProvider;